// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UulizW8Ff48PYT8g86Uo{flex-direction:column;flex-grow:1;gap:32px;padding:16px 24px 24px;display:flex;overflow:auto}.IV5_u50bu1wTUhKy8Jb3{gap:8px;margin-top:12px;display:flex}.YNPOfLpGKwweMLXziX99{flex-direction:column;flex-grow:1;display:flex;overflow:auto}.n4yUOPQxLzI0jlUhPwDQ{grid-template-columns:130px 1fr;align-items:flex-start;display:grid}.n4yUOPQxLzI0jlUhPwDQ .G9gfI0G4NsAOF81iXgkx{padding-top:4px;padding-bottom:4px}.n4yUOPQxLzI0jlUhPwDQ .cJ976ua6SDY5swnQwt8j{align-self:stretch;align-items:center;gap:8px;padding:4px 4px 4px 12px;display:flex}.n4yUOPQxLzI0jlUhPwDQ .mZ2svvPs_cGdW0wYBZVy{padding-top:4px;padding-bottom:4px;word-break:break-word;flex-direction:column;padding-right:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `UulizW8Ff48PYT8g86Uo`,
	"info": `IV5_u50bu1wTUhKy8Jb3`,
	"body": `YNPOfLpGKwweMLXziX99`,
	"row": `n4yUOPQxLzI0jlUhPwDQ`,
	"title": `G9gfI0G4NsAOF81iXgkx`,
	"value": `cJ976ua6SDY5swnQwt8j`,
	"content": `mZ2svvPs_cGdW0wYBZVy`
};
export default ___CSS_LOADER_EXPORT___;
